export default "__VITE_ASSET__CVi0XyDX__"